import { render } from "./to-dos.vue?vue&type=template&id=658fdc2a&lang=pug"
import script from "./to-dos.vue?vue&type=script&lang=js"
export * from "./to-dos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__